export const profilePageLayoutByVariant = {
  desktop: {
    header: {
      left: 0,
      position: 'absolute',
      px: 156,
      right: 0,
    },
    pb: 156,
    pl: 156,
    pr: 156,
    px: 156,
  },
  laptop: {
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pb: 24,
    pl: 24,
    pr: 24,
    px: 24,
  },
  mobile: {
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pb: 24,
    pl: 24,
    pr: 24,
    px: 24,
  },
  tablet: {
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pb: 24,
    pl: 24,
    pr: 24,
    px: 24,
  },
};
